// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PTabletOutlinedSvg from "@fishx/icons-svg/es/asn/PTabletOutlined";
import FishxIcon from '../components/FishxIcon';

var PTabletOutlined = function PTabletOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PTabletOutlinedSvg
  }));
};

PTabletOutlined.displayName = 'PTabletOutlined';
export default React.forwardRef(PTabletOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PTabletOutlined.js
// module id = 3678
// module chunks = 0